import type { InputChangeDetails } from "@9amhealth/wcl";

/**
 * `nine-input` strips mask separators from the value it emits — a blood pressure
 * reading shown as "160/90" arrives as "16090". Fields whose stored value has to
 * keep the separators read `maskedValue` instead.
 */
const resolveInputChangeValue = (
  detail: InputChangeDetails,
  useMaskedValue?: boolean
): string => {
  if (useMaskedValue && typeof detail.maskedValue === "string") {
    return detail.maskedValue;
  }
  return detail.value;
};

export default resolveInputChangeValue;
